import moment from 'moment'
export const customer = {
    state: {
        status: 'initial',
        currentAddressId: 0,
        customer: {
            vatin:
                process.env.NODE_ENV !== 'production' &&
                process.env.VUE_APP_VATIN
                    ? process.env.VUE_APP_VATIN
                    : '',
            companyName: '',
            city: '',
            street: '',
            postcode: '',
            einvoiceRemarks: '',
            addresses: [],
            contactPerson: {
                firstName: '',
                lastName: '',
                phone: '',
                email: ''
            }
        }
    },
    mutations: {
        SET_CUSTOMER_STATUS(state, status) {
            state.status = status
        },
        SET_CUSTOMER(state, customer) {
            this.$vue.set(state, 'customer', customer)
        },
        SET_CUSTOMER_FIELD(state, payload) {
            this.$vue.set(state.customer, payload.field, payload.value)
        },
        SET_CUSTOMER_ADDRESS_FIELD(state, payload) {
            this.$vue.set(
                state.customer.addresses[payload.addressId],
                payload.field,
                payload.value
            )
        },
        SET_CUSTOMER_CONTACTPERSON_FIELD(state, payload) {
            this.$vue.set(
                state.customer.contactPerson,
                payload.field,
                payload.value
            )
        },
        SET_CUSTOMER_CURRENT_ADDRESS_ID(state, payload) {
            state.currentAddressId = payload
        },
        RESET_CUSTOMER_ADDRESS(state, addressId) {
            if (typeof state.customer.addresses[addressId] === 'undefined') {
                this.$vue.set(state.customer.addresses, addressId, {})
            }
            this.$vue.set(
                state.customer.addresses[addressId],
                'addressExternalId',
                ''
            )
            this.$vue.set(state.customer.addresses[addressId], 'city', '')
            this.$vue.set(state.customer.addresses[addressId], 'street', '')
            this.$vue.set(state.customer.addresses[addressId], 'number', '')
            this.$vue.set(state.customer.addresses[addressId], 'postcode', '')
            this.$vue.set(
                state.customer.addresses[addressId],
                'dateFrom',
                moment().format('YYYY-MM-DD')
            )
            this.$vue.set(
                state.customer.addresses[addressId],
                'hoursFrom',
                '08:00'
            )
            this.$vue.set(
                state.customer.addresses[addressId],
                'hoursTo',
                '16:00'
            )
            // we send this to backend as the payload will not be verified
            this.$vue.set(
                state.customer.addresses[addressId],
                'earliestFrom',
                '08:00'
            )
            this.$vue.set(state.customer.addresses[addressId], 'remarks', '')
            this.$vue.set(state.customer.addresses[addressId], 'geometry', {
                lat: 0,
                lng: 0
            })
            this.$vue.set(
                state.customer.addresses[addressId],
                'supportedDays',
                []
            )
        },
        REMOVE_CUSTOMER_ADDRESS(state, addressId) {
            this.$vue.delete(state.customer.addresses, addressId)
        }
    },
    actions: {
        detailsByVatin({ state, commit, dispatch }, vatin) {
            if (vatin === '') {
                return Promise.reject(new Error('No VAT number'))
            }
            commit('SET_CUSTOMER_STATUS', 'checkingVatin')
            return this.$api
                .get(`b2b/v2/companies/address/${vatin}`)
                .then(response => {
                    commit('SET_CUSTOMER_STATUS', 'idle')
                    return Promise.resolve(response.data)
                })
                .catch(error => {
                    commit('SET_CUSTOMER_STATUS', 'idle')
                    return Promise.reject(new Error(error))
                })
        },
        retrieveAddressByVatin({ state, commit, dispatch }, vatin) {
            return new Promise((resolve, reject) => {
                // check if vatin is given
                if (vatin === '') {
                    reject(new Error('No VAT number'))
                }
                commit('SET_CUSTOMER_STATUS', 'checkingVatin')
                this.$api
                    .get(`b2b/v2/companies/address/${vatin}`)
                    .then(response => {
                        if (response.status === 200) {
                            // set invoice data
                            commit('SET_CUSTOMER_FIELD', {
                                field: 'vatin',
                                value: vatin
                            })
                            commit('SET_CUSTOMER_FIELD', {
                                field: 'companyName',
                                value: response.data.data.company_name.trim()
                            })
                            commit('SET_CUSTOMER_FIELD', {
                                field: 'city',
                                value: response.data.data.city.trim()
                            })
                            commit('SET_CUSTOMER_FIELD', {
                                field: 'street',
                                value: response.data.data.address.trim()
                            })
                            commit('SET_CUSTOMER_FIELD', {
                                field: 'postcode',
                                value: response.data.data.postcode.trim()
                            })
                            // set first address data
                            commit('RESET_CUSTOMER_ADDRESS', 0)
                            commit('SET_CUSTOMER_ADDRESS_FIELD', {
                                addressId: 0,
                                field: 'city',
                                value: response.data.data.city
                            })
                            commit('SET_CUSTOMER_ADDRESS_FIELD', {
                                addressId: 0,
                                field: 'street',
                                value: response.data.data.address
                            })
                            commit('SET_CUSTOMER_ADDRESS_FIELD', {
                                addressId: 0,
                                field: 'number',
                                value: ''
                            })
                            commit('SET_CUSTOMER_ADDRESS_FIELD', {
                                addressId: 0,
                                field: 'postcode',
                                value: response.data.data.postcode
                            })
                            // save in local storage
                            dispatch('saveState', {
                                customer: state.customer
                            }).then(() => {
                                commit('SET_CUSTOMER_STATUS', 'idle')
                                resolve()
                            })
                        } else {
                            dispatch('saveState', {
                                customer: state.customer
                            }).then(() => {
                                commit('RESET_CUSTOMER_ADDRESS', 0)
                                commit('SET_CUSTOMER_FIELD', {
                                    addressId: 0,
                                    field: 'vatin',
                                    value: state.customer.vatin
                                })
                                commit('SET_CUSTOMER_STATUS', 'idle')
                                reject(new Error('API error'))
                            })
                        }
                    })
                    .catch(() => {
                        dispatch('saveState', {
                            customer: state.customer
                        }).then(() => {
                            commit('RESET_CUSTOMER_ADDRESS', 0)
                            commit('SET_CUSTOMER_FIELD', {
                                addressId: 0,
                                field: 'vatin',
                                value: state.customer.vatin
                            })
                            commit('SET_CUSTOMER_STATUS', 'idle')
                            reject(new Error('API error'))
                        })
                    })
            })
        },
        addAddressWithId({ state, commit, dispatch, getters }, payload) {
            commit('SET_CUSTOMER_STATUS', 'savingAddress')
            // get address id info
            const address = getters['companies/addresses'].find(
                address => address.id === payload.addressId
            )
            if (
                !address ||
                !Object.prototype.hasOwnProperty.call(address, 'address')
            ) {
                throw Error(
                    `No address details with given ID: ${payload.addressId}`
                )
            }
            const newAddressId = payload.newAddress
                ? state.customer.addresses.length
                : 0
            commit('RESET_CUSTOMER_ADDRESS', newAddressId)
            commit('SET_CUSTOMER_CURRENT_ADDRESS_ID', newAddressId)
            commit('SET_CUSTOMER_ADDRESS_FIELD', {
                addressId: newAddressId,
                field: 'addressExternalId',
                value: payload.addressId
            })
            commit('SET_CUSTOMER_ADDRESS_FIELD', {
                addressId: newAddressId,
                field: 'address',
                value: address.address
            })
            commit('SET_CUSTOMER_ADDRESS_FIELD', {
                addressId: newAddressId,
                field: 'warehouse',
                value: {
                    external_supplier: address.external_supplier,
                    id: address.warehouse_id,
                    name: address.warehouse_name
                }
            })
            dispatch('saveState', { customer: state.customer }).then(() => {
                commit('SET_CUSTOMER_STATUS', 'idle')
                return Promise.resolve()
            })
        },
        resetCustomerAddress({ commit }, addressId) {
            commit('RESET_CUSTOMER_ADDRESS', addressId)
        },
        checkSupportedDays(_, payload) {
            return new Promise((resolve, reject) => {
                this.$api
                    .get(
                        `b2b/v2/management/check_coordinates/${payload.geometry.lat}/${payload.geometry.lng}/${payload.days}/${payload.warehouse.id}`
                    )
                    .then(response => {
                        if (response.status === 200) {
                            resolve(response.data.data)
                        }
                        reject(new Error('API error'))
                    })
            })
        },
        checkSupportedDaysAndSave({ commit, state }, payload) {
            return new Promise((resolve, reject) => {
                // -1 because while adding address (not second step) there is already created address by addAddressWithId action
                const newAddressId = payload.newAddress
                    ? state.customer.addresses.length - 1
                    : 0
                this.$api
                    .get(
                        `b2b/v2/management/check_coordinates/${payload.geometry.lat}/${payload.geometry.lng}/${payload.days}/${payload.warehouse.id}`
                    )
                    .then(response => {
                        if (response.status === 200) {
                            const supportedDays = response.data.data
                            if (
                                supportedDays.some(
                                    item => item.is_active === true
                                )
                            ) {
                                commit('SET_CUSTOMER_ADDRESS_FIELD', {
                                    addressId: newAddressId,
                                    field: 'supportedDays',
                                    value: supportedDays
                                })
                                if (payload.companySize) {
                                    commit('SET_CUSTOMER_ADDRESS_FIELD', {
                                        addressId: newAddressId,
                                        field: 'companySize',
                                        value: payload.companySize
                                    })
                                }
                                resolve(response.data)
                            } else {
                                return Promise.reject(new Error(response))
                            }
                        }
                        reject(new Error('API error'))
                    })
                    .catch(error => reject(error))
            })
        },
        checkAddressAvailability(
            { state, getters, commit, dispatch },
            payload
        ) {
            return new Promise((resolve, reject) => {
                commit('SET_CUSTOMER_STATUS', 'checkingAddressAvailability')
                // get warehouse ID
                this.$api
                    .get(
                        `b2b/v2/management/warehouse/${payload.geometry.lat}/${payload.geometry.lng}`
                    )
                    .then(response => {
                        const warehouse = response.data.data
                        this.$api
                            .get(
                                `b2b/v2/management/check_coordinates/${payload.geometry.lat}/${payload.geometry.lng}/${payload.days}/${warehouse.id}`
                            )
                            .then(response => {
                                if (response.status === 200) {
                                    const supportedDays = response.data.data
                                    if (
                                        supportedDays.some(
                                            item => item.is_active === true
                                        )
                                    ) {
                                        if (payload.newAddress) {
                                            const newAddressId =
                                                state.customer.addresses.length
                                            commit(
                                                'RESET_CUSTOMER_ADDRESS',
                                                newAddressId
                                            )
                                            commit(
                                                'SET_CUSTOMER_CURRENT_ADDRESS_ID',
                                                newAddressId
                                            )
                                        } else {
                                            commit('RESET_CUSTOMER_ADDRESS', 0)
                                            commit(
                                                'SET_CUSTOMER_CURRENT_ADDRESS_ID',
                                                0
                                            )
                                        }
                                        commit('SET_CUSTOMER_ADDRESS_FIELD', {
                                            addressId: getters.currentAddressId,
                                            field: 'street',
                                            value: payload.deliveryStreet
                                        })
                                        commit('SET_CUSTOMER_ADDRESS_FIELD', {
                                            addressId: getters.currentAddressId,
                                            field: 'number',
                                            value: payload.deliveryNumber
                                        })
                                        commit('SET_CUSTOMER_ADDRESS_FIELD', {
                                            addressId: getters.currentAddressId,
                                            field: 'postcode',
                                            value: payload.deliveryPostcode
                                        })
                                        commit('SET_CUSTOMER_ADDRESS_FIELD', {
                                            addressId: getters.currentAddressId,
                                            field: 'city',
                                            value: payload.deliveryCity
                                        })
                                        commit('SET_CUSTOMER_ADDRESS_FIELD', {
                                            addressId: getters.currentAddressId,
                                            field: 'geometry',
                                            value: payload.geometry
                                        })
                                        commit('SET_CUSTOMER_ADDRESS_FIELD', {
                                            addressId: getters.currentAddressId,
                                            field: 'warehouse',
                                            value: warehouse
                                        })
                                        commit('SET_CUSTOMER_ADDRESS_FIELD', {
                                            addressId: getters.currentAddressId,
                                            field: 'supportedDays',
                                            value: supportedDays
                                        })
                                        commit('SET_CUSTOMER_ADDRESS_FIELD', {
                                            addressId: getters.currentAddressId,
                                            field: 'companySize',
                                            value: payload.companySize
                                        })
                                        commit('SET_CUSTOMER_ADDRESS_FIELD', {
                                            addressId: getters.currentAddressId,
                                            field: 'contactPerson',
                                            value: payload.contactPerson
                                        })
                                        commit('SET_CUSTOMER_ADDRESS_FIELD', {
                                            addressId: getters.currentAddressId,
                                            field: 'address',
                                            value: `${payload.deliveryStreet} ${payload.deliveryNumber}, ${payload.deliveryPostcode} ${payload.deliveryCity}`
                                        })
                                        dispatch('saveState', {
                                            customer: getters.customer
                                        }).then(() => {
                                            commit(
                                                'SET_CUSTOMER_STATUS',
                                                'idle'
                                            )
                                            resolve()
                                        })
                                    } else {
                                        commit('SET_CUSTOMER_STATUS', 'idle')
                                        reject(
                                            new Error('Location not availible')
                                        )
                                    }
                                } else {
                                    commit('SET_CUSTOMER_STATUS', 'idle')
                                    reject(new Error('API error'))
                                }
                            })
                            .catch(error => {
                                commit('SET_CUSTOMER_STATUS', 'idle')
                                console.error(error)
                                reject(new Error('API error'))
                            })
                    })
                    .catch(() => {
                        commit('SET_CUSTOMER_STATUS', 'idle')
                        reject(new Error('Location not availible'))
                    })
            })
        },
        addNewAddress({ state, commit }, payload) {
            const newAddressId = state.customer.addresses.length
            commit('RESET_CUSTOMER_ADDRESS', newAddressId)
            commit('SET_CUSTOMER_CURRENT_ADDRESS_ID', newAddressId)
            commit('SET_CUSTOMER_ADDRESS_FIELD', {
                addressId: newAddressId,
                field: 'street',
                value: payload.deliveryStreet
            })
            commit('SET_CUSTOMER_ADDRESS_FIELD', {
                addressId: newAddressId,
                field: 'number',
                value: payload.deliveryNumber
            })
            commit('SET_CUSTOMER_ADDRESS_FIELD', {
                addressId: newAddressId,
                field: 'postcode',
                value: payload.deliveryPostcode
            })
            commit('SET_CUSTOMER_ADDRESS_FIELD', {
                addressId: newAddressId,
                field: 'city',
                value: payload.deliveryCity
            })
            commit('SET_CUSTOMER_ADDRESS_FIELD', {
                addressId: newAddressId,
                field: 'geometry',
                value: payload.geometry
            })
            commit('SET_CUSTOMER_ADDRESS_FIELD', {
                addressId: newAddressId,
                field: 'contactPerson',
                value: payload.contactPerson
            })
        },
        setCurrentAddress({ commit, dispatch }, payload) {
            commit('SET_CUSTOMER_CURRENT_ADDRESS_ID', payload)
        },
        removeAddress({ state, commit, dispatch }, addressId) {
            commit('REMOVE_CUSTOMER_ADDRESS', addressId)
            dispatch('removeOrdersFromAddress', addressId)
            commit('SET_CUSTOMER_CURRENT_ADDRESS_ID', 0)
            commit('SET_CUSTOMER_STATUS', 'idle')
        },
        setCustomer({ commit }, payload) {
            commit('SET_CUSTOMER', payload)
        },
        setCustomerField({ state, commit, dispatch }, payload) {
            commit('SET_CUSTOMER_FIELD', payload)
            dispatch('saveState', { customer: state.customer })
        },
        setCustomerAddressField({ state, commit, dispatch }, payload) {
            commit('SET_CUSTOMER_ADDRESS_FIELD', payload)
            dispatch('saveState', { customer: state.customer })
        },
        setCustomerContactPerson({ state, commit, dispatch }, payload) {
            commit('SET_CUSTOMER_CONTACTPERSON_FIELD', payload)
            dispatch('saveState', { customer: state.customer })
        },
        checkMinimumCartDate({ state, getters, dispatch }) {
            for (const [
                addressId,
                address
            ] of state.customer.addresses.entries()) {
                if (moment(address.dateFrom).isBefore(getters.minimumDate)) {
                    dispatch('setCustomerAddressField', {
                        addressId,
                        field: 'dateFrom',
                        value: getters.minimumDate
                    })
                }
            }
        }
    },
    getters: {
        customer: state => {
            return state.customer
        },
        customerStatus: state => {
            return state.status
        },
        customerAddressAvailibleDayInWeek: (state, getters) => (
            addressId,
            dayInWeek
        ) => {
            if (getters.customerAddressField(addressId, 'supportedDays')) {
                return getters
                    .customerAddressField(addressId, 'supportedDays')
                    .find(item => item.day === dayInWeek + 1).is_active
            }
        },
        currentAddressId: state => {
            return state.currentAddressId
        },
        currentAddressExternalId: (state, getters) => {
            if (
                Object.keys(state.customer.addresses).length > 0 &&
                state.customer.addresses[getters.currentAddressId]
            ) {
                return state.customer.addresses[getters.currentAddressId].addressExternalId || null
            }
            return null
        },
        customerAddresses: state => {
            if (state.customer.addresses) {
                return state.customer.addresses
            }
        },
        customerAddressExternalSupplier: state => addressId => {
            if (
                Object.keys(state.customer.addresses).length > 0 &&
                state.customer.addresses[addressId]
            ) {
                return state.customer.addresses[addressId].warehouse
                    .external_supplier
                    ? 1
                    : 0
            }
        },
        customerAddressWarehouseId: state => addressId => {
            if (
                Object.keys(state.customer.addresses).length > 0 &&
                state.customer.addresses[addressId]
            ) {
                return state.customer.addresses[addressId].warehouse.id
            }
            return null
        },
        // customerAddressWarehouseIdByExternalAddressId: state => externalAddressId => {
        //     if (Object.keys(state.customer.addresses).length > 0) {
        //         const address = state.customer.addresses.find(item => item.addressExternalId === externalAddressId)
        //         return address.warehouse.id || null
        //     }
        //     return null
        // },
        customerAddress: state => addressId => {
            if (
                Object.keys(state.customer.addresses).length > 0 &&
                state.customer.addresses[addressId]
            ) {
                return state.customer.addresses[addressId]
            }
        },
        customerAddressField: state => (addressId, field) => {
            if (
                Object.keys(state.customer.addresses).length > 0 &&
                typeof state.customer.addresses[addressId] !== 'undefined' &&
                Object.prototype.hasOwnProperty.call(
                    state.customer.addresses[addressId],
                    field
                )
            ) {
                return state.customer.addresses[addressId][field]
            }
        },
        customerContactPerson: state => state.customer.contactPerson
    }
}
